<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import {slide} from 'svelte/transition';
    import Validator from '../Helpers/Validator';
    import http from '../api/http.js';
    import { selectedGroup } from '../store.js'; 
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput, ButtonGroup } from 'sveltestrap';
    import Tooltip from '../reusable components/Tooltip.svelte'
    import MultiStep from '../components/MultiStep.svelte';
    import { Dashboard } from "@uppy/svelte";
    import Uppy from "@uppy/core";
    import AwsS3 from "@uppy/aws-s3";
    import '@uppy/core/dist/style.css';
    import '@uppy/dashboard/dist/style.css';
    import { addRemoveProgramsImage } from '../common/Images.js'
    
    const dispatch = createEventDispatcher();
    
    const softwareMode = 'package'
    const versionMode = 'version'

    const installationTransferType = 'installation';
    const transferTransferType = 'transfer';

    let multiStepValue = 0;
    const maxMultiStepValue = 2;
    let restartCountTime = 0;

    let packageType;
    let shown = false;
    let transferType = 'installation';
    let packageVersionDescription = '';
    let softwarePackageName = '';
    let installerArguemnts = '';
    let restartMessage = '';
    let destinationPath = '';
    let preInstall = '';
    let postInstall = '';
    let cachable = false;
    let softwarePackages = [];
    let selected = {
        name: '',
    };
    let primaryFiles = [];
    let privateSoftware = [];
    let uploads = [];
    let errorMessage = '';
    let mode = softwareMode;
    let modeText = 'Create Package';
    let selectedPackage;
    let selectedPackageId;
    let usePreExistingPreInstallCommands = false;
    let usePreExistingPostInstallCommands = false;
    let useExistingDestinationPath = false;
    let usePreExistingInstallerArguments = false;
    let showSelectPrimaryFiles = false;
    let forceRestart = false;
    const toggleForceRestart = () => forceRestart = !forceRestart;
    let latestPackageVersion = {
        action: ''
    };
    let transferTypeText = 'Installer Arguments';
    let installerTooltip = [
        {
            "name": "Example 1",
            "value": "/quiet",
            "color": "info"
        },
        {
            "name": "Example 2",
            "value": "/S",
            "color": "info"
        },
        {
            "name": "More Information",
            "value": "For more information about installer arguments, please refer to your install documentation",
            "color": "primary"
        },
    ];

    let packageNameTooltip= "The package name needs to match the name displayed in add or remove programs for the system to accurately match software that is installed. In the example below your package name would need to be Notepad++ (64-bit x64)"

    let uppy = new Uppy();
    let uppyProps = {
        doneButtonHandler: null,
        showLinkToFileUploadResult: false,
        height: 225,
        proudlyDisplayPoweredByUppy: false,
        showRemoveButtonAfterComplete: true,
        fileManagerSelectionType: "both",
    };

    $:{
        if(selectedPackage != undefined && selectedPackage.versionCount > 0){
            if(mode == versionMode){
                getLastVersion(selectedPackage.id);
                transferType = selectedPackage.packageType.toLocaleLowerCase() == installationTransferType.toLocaleLowerCase() ? installationTransferType:transferTransferType;
            }
        }
    }

    $:{
        forceRestart;
        setRestartRelatedSettings();
    }


    function setMode(selectedMode){
        if(selectedMode == softwareMode){
            transferType = installationTransferType
            errorMessage = "";
            mode = softwareMode;
            latestPackageVersion = {
                action: ''
            };
            modeText = 'Create Package';
            softwarePackageName = "";
            packageVersionDescription = "";
            installerArguemnts = "";
            restartMessage = "";
            restartCountTime = 0;
            forceRestart = false;
            destinationPath = "";
            preInstall = "";
            postInstall = "";
            cachable = false;
            primaryFiles = [];
            uploads = [];
            errorMessage = "";
        }
        else if(selectedMode == versionMode){
            transferType = '';
            mode = versionMode;
            errorMessage = "";
            modeText = `Create Package Version (${selectedPackage.name})`;
            packageVersionDescription = "";
            installerArguemnts = "";
            restartMessage = "";
            restartCountTime = 0;
            forceRestart = false;
            destinationPath = "";
            preInstall = "";
            postInstall = "";
            cachable = false;
            primaryFiles = [];
            uploads = [];
            errorMessage = "";
        }
    }

    function changeTransferType(type){
        if(type == installationTransferType){
            transferType = installationTransferType;
            transferTypeText = 'Installation';
        }
        else if(type == transferTransferType){
            transferType = transferTransferType;
            transferTypeText = 'Data Transfer';
        }
    }

    function setUsePreExistingPreInstallCommands(){
        if(usePreExistingPreInstallCommands){
            usePreExistingPreInstallCommands = false;
            preInstall = "";
        }
        else{
            usePreExistingPreInstallCommands = true;
            preInstall = latestPackageVersion.preinstall;
        }
    }

    function setUsePreExistingPostInstallCommands(){
        if(usePreExistingPostInstallCommands){
            usePreExistingPostInstallCommands = false;
            postInstall = "";
        }
        else{
            usePreExistingPostInstallCommands = true;
            postInstall = latestPackageVersion.postinstall;
        }
    }

    function setUseExistingDestinationPath(){
        if(useExistingDestinationPath){
           useExistingDestinationPath = false;
           destinationPath = "";
        }
        else{
            useExistingDestinationPath = true;
            destinationPath = latestPackageVersion.destination;
        }
    }

    function setUsePreExistingInstallerArguments(){
        if(usePreExistingInstallerArguments){
            usePreExistingInstallerArguments = false;
            installerArguemnts = "";
            restartMessage = "";
            restartCountTime = 0;
            forceRestart = false;
        }
        else{
            usePreExistingInstallerArguments = true;
            installerArguemnts = latestPackageVersion.cmdLineArguments;
            restartMessage = latestPackageVersion.restartMessage;
            restartCountTime = latestPackageVersion.restartCountDownTime;
            forceRestart = latestPackageVersion.restartRequired;
        }
    }

    function toggle() {
        if(shown){
            shown = false;
            resetModal();
        }
        else{
            shown = true;
        }
    }

    function resetModal(){
        transferType = installationTransferType;
        packageVersionDescription = '';
        softwarePackageName = '';
        installerArguemnts = '';
        restartMessage = '';
        restartCountTime = 0;
        forceRestart = false;
        destinationPath = '';
        preInstall = '';
        postInstall = '';
        cachable = false;
        softwarePackages = [];
        selected = null;
        primaryFiles = [];
        errorMessage = '';
        mode = softwareMode;
        modeText = 'Create Package';
        latestPackageVersion = {
            action: ''
        };
        useExistingDestinationPath = false;
        usePreExistingInstallerArguments = false;
        usePreExistingPreInstallCommands = false;
        usePreExistingPostInstallCommands = false;
        showSelectPrimaryFiles = false;
        uppy.reset();
        multiStepValue = 0;
        packageType = '';
    }

    function validateName(name){
        if(name.length > 100){
            name = "";
            errorMessage = "Name cannot be longer than 100 characters.";
        }
    }

    function validateDescription(description){
        if(description.length > 100){
            description = "";
            errorMessage = "Description cannot be longer than 100 characters.";
        }
        else{
            errorMessage = "";
        }
    }

    function validateCommands(command){
        if(command.length > 1024){
            errorMessage = "Post Install and Pre Install commands cannot be longer than 1024 characters.";
        }
        else{
            errorMessage = "";
        }
    }

    function validatePrimaryFile(){
        if(selected != null){
            errorMessage = "";
        }
        else{
            errorMessage = "Please select a primary file.";
        }
    }

    function validateRestartMessage(){
        if(restartMessage.length < 101){
            errorMessage = "";
        }
        else{
            errorMessage = "Custom Restart Message must be less than 100 characters in length.";
        }
    }

    function runValidation(){    
        if(showSelectPrimaryFiles){
            validatePrimaryFile();
        }
        validateRestartMessage();
        if(errorMessage == ""){
            postSoftware();
        }
    }

    async function postSoftware(){
        let uploadFiles = primaryFiles.map(file => ({
            name: file.name,
            s3Id: file.s3Id,
            size: file.size,
            path: file.path
        }))
        let software = {
            name: softwarePackageName,
            description: packageVersionDescription,
            installerArguments: installerArguemnts,
            forceRestart: forceRestart,
            restartMessage: restartMessage,
            restartCountTime: restartCountTime,
            packageType: versionMode == mode ? packageType : transferType,
            preInstallBat : preInstall,
            postInstallBat : postInstall,
            destination: destinationPath,
            cachable: cachable,
            primaryFile : selected.name,
            files : uploadFiles
        }
        let res = '';
        if (mode == softwareMode){
             res = await http.post(window.apiBaseUrl + `/deploy/dashboard/software/${$selectedGroup}`, software);
        }
        else if(mode == versionMode){
            res = await http.post(window.apiBaseUrl + `/deploy/dashboard/software/version/${selectedPackageId}/${$selectedGroup}`, software);
        }
        if (res.status == 200){
            dispatch('softwareCreated');
            toggle();
        }
        else{
            errorMessage = "Something went wrong, please try again.";
        }        
    }
    
    export async function show(mode, selectedPackageArg){
        if(mode == softwareMode){
            setMode(softwareMode);
        }
        else if(mode == versionMode){            
            selectedPackage = selectedPackageArg;
            setMode(versionMode);
            selectedPackageId = selectedPackageArg.id;
            packageType = selectedPackageArg.packageType;
            await getLastVersion(selectedPackageArg.id);
            setUseExistingDestinationPath();
            setUsePreExistingInstallerArguments();
            setUsePreExistingPreInstallCommands();
            setUsePreExistingPostInstallCommands();
        }
        shown = true;
        await getSoftware();
    }

    function validateInstallerArguments(installerArguments){
        if(installerArguments.length > 512){
            installerArguments = "";
            errorMessage = "Installer Arguments cannot be longer than 512 characters.";
        }
        else{
            errorMessage = "";
        }
    }

    function validateCustomRestartMessage(message){
        if(message.length > 100){
            errorMessage = "Customer Message cannot be longer than 100 characters.";
        }
        else{
            errorMessage = "";
        }
    }

    async function getSoftware(){
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/private/${$selectedGroup}`);
        privateSoftware = await res.json();
    }

    async function getLastVersion(packageId) {
    const res = await http.get(window.apiBaseUrl +`/deploy/dashboard/software/latestversion/${packageId}/${$selectedGroup}`);
    if (res.status == 200) {
        latestPackageVersion = await res.json();
    }
  }

 async function uppySetup() {
    uppy.use(AwsS3, {
      getUploadParameters(file) {
        return fetch(window.apiBaseUrl + "/deploy/dashboard/uploads", {
          method: "post",
          headers: {
            accept: "application/json",
            "content-type": "application/json",
          },
          body: JSON.stringify({
            filename: file.name,
            contentType: file.type,
          }),
        })
          .then(async (response) => {
            const r = await response.json();
            return r;
          })
          .then((data) => {
            return {
              method: data.method,
              url: data.url,
              fields: data.fields,
            };
          });
      },
    });
    uppy.on("file-removed", (result) => {
      var itemToRemove = (item) => item.uploadURL == result.uploadURL;
      var index = uploads.findIndex(itemToRemove);
      uploads.splice(index, 1);
    });
    uppy.on("complete", (result) => {
      let files = result.successful;
      uploads = uploads.concat(files);
      uploads.forEach((upload) => {
        if(!primaryFiles.some(f => f.s3Id === upload.uploadURL)){
            primaryFiles.push({
                name: upload.name,
                label: upload.name,
                s3Id: upload.uploadURL,
                size: upload.data.size,
                path: upload.data.webkitRelativePath,
            });
        }        
      });
      primaryFiles = primaryFiles;
      selected = primaryFiles[0];
      if(transferType == installationTransferType || latestPackageVersion.action.toLocaleLowerCase() == "install"){
        showSelectPrimaryFiles = true;
      }
    });
  }

  function setRestartRelatedSettings(){
    if(!forceRestart){
        restartCountTime = 0;
        restartMessage = "";
    }
  }

    onMount(async () => {
        await uppySetup();
    });
</script>

<Modal size="lg" isOpen={shown} {toggle}>
    <ModalHeader {toggle}>
        Manage Packages
    </ModalHeader>
    <ModalBody>
        <div class="container">
            <div class=" d-flex">
                 <h5 class="mt-2 m-2 modalHeading">{modeText}</h5>
            </div>
            <div class="row">
                <div class="col">
                    <h4 class="input-header mt-2 m-2 mb-2">Name</h4>
                    <input id="software-name-input" type="text" class="form-control" bind:value={softwarePackageName} placeholder="Package Name" on:input={() => validateName(softwarePackageName)}>
                    <small class="text-danger">Package name must match the name displayed in add and remove programs</small> <Tooltip content={packageNameTooltip} legend={false} title={"Package Name"} contentImage={true} contentImageSource={addRemoveProgramsImage}> <i class="fad fa-question-circle fa-sm font-weight-normal"></i></Tooltip>
                </div>
                <div class="col">
                    <h4 class="input-header mt-2 mb-2 m-2">Description</h4>
                    <input id="version-description-input" type="text" class="form-control" bind:value={packageVersionDescription} placeholder="Version Description" on:input={() => validateDescription(packageVersionDescription)}>
                </div>
            </div>
            {#if multiStepValue > 0}
                <div transition:slide>
                    {#if mode != versionMode}
                        <div class="d-flex mt-2 mb-2">
                            <h4 class="modalHeading m-2">{transferTypeText}</h4>
                            <div class="ml-auto">
                                <button id="installation-type-button" class="btn btn-link {transferType === transferType == installationTransferType ? 'active' : ''}" on:click={() => changeTransferType(installationTransferType)} class:active={transferType == installationTransferType}>Installation</button>
                                <button id="data-transfer-type-button" class="btn btn-link {transferType === transferType == transferTransferType ? 'active' : ''}" on:click={() => changeTransferType(transferTransferType)} class:active={transferType == transferTransferType}>Data Transfer</button>
                            </div>
                        </div>
                    {/if}
                    {#if transferType == installationTransferType || latestPackageVersion.action.toLocaleLowerCase() == "install"}
                        <div class="d-flex mt-2 mb-2">
                            <h4 class="input-header mb-3 m-2">Installer Arguments    
                                <Tooltip content={installerTooltip} legend={true} title={"Installer Arguments"}> <i class="fad fa-question-circle fa-sm font-weight-normal"></i></Tooltip>
                            </h4>
                            {#if mode == versionMode}
                                <div class="ml-auto">
                                    <CustomInput type="switch" checked={usePreExistingInstallerArguments == true} id="setInstallerArguments" on:change={() => setUsePreExistingInstallerArguments()} label="Use Existing Arguments"></CustomInput>
                                </div>
                            {/if}
                        </div>
                        <input id="installer-arguments-input" type="text" class="form-control" placeholder="Installer Arguments" bind:value={installerArguemnts} on:input={() => validateInstallerArguments(installerArguemnts)} disabled={usePreExistingInstallerArguments}>                        
                        <div class="d-flex mt-2 mb-2">
                            <h4 class="modalHeading m-2">Restart Settings</h4>
                            <CustomInput type="switch" checked={forceRestart == true} id="setforceRestart" on:change={() => toggleForceRestart()} label="Enable Force Restart" class="ml-auto"></CustomInput>
                        </div>
                        <div>
                            <h4 class="input-header mb-3 m-2">Restart Timer (Seconds)</h4>
                            <input type="number" class="form-control" id="restart-countdown-time" min=0  bind:value={restartCountTime} disabled={!forceRestart}>
                            <h4 class="input-header mb-3 m-2">Custom Restart Message</h4>
                            <input id="restart-message-input" type="text" class="form-control" placeholder="Custom Restart Message" bind:value={restartMessage} on:input={() => validateCustomRestartMessage(restartMessage)} disabled={!forceRestart}>  
                        </div>
                        <div class="mt-2 mb-2">
                            <div class="d-flex">
                                <h4 class="input-header mb-3 m-2">Pre-Install Commands</h4>
                                {#if mode == versionMode}
                                    <div class="ml-auto">
                                        <CustomInput type="switch" checked={usePreExistingPreInstallCommands == true} id="setPreInstallCommands" on:change={() => setUsePreExistingPreInstallCommands()} label="Use Existing Commands"></CustomInput>
                                    </div>
                                {/if}
                            </div>
                            <textarea id="pre-install-input" class="form-control" bind:value={preInstall} placeholder="Pre-Install (.bat commands)" disabled={usePreExistingPreInstallCommands == true} on:input={() => validateCommands(preInstall)}/>
                                <div class="mt-2 mb-2">
                                <div class="d-flex">
                                    <h4 class="input-header mt-2 mb-3 m-2">Post Install Commands</h4>
                                    {#if mode == versionMode}
                                        <div class="ml-auto">
                                            <CustomInput type="switch" checked={usePreExistingPostInstallCommands == true} id="setPostInstallCommands" on:change={() => setUsePreExistingPostInstallCommands()} label="Use Existing Commands"></CustomInput>
                                        </div>
                                    {/if}
                                </div>
                                <textarea id="post-install-input" class="form-control"bind:value={postInstall} placeholder="Post-Install (.bat commands)" disabled={usePreExistingPostInstallCommands == true} on:input={() => validateCommands(postInstall)}/>
                            </div>
                        </div>
                        {:else if transferType == transferTransferType || latestPackageVersion.action.toLocaleLowerCase() == "copy"}
                            <div class="mt-2 mb-2">
                            <div class="d-flex">
                                <h4 class="input-header mt-2 m-2">Destination Path</h4>
                                {#if mode == versionMode}
                                    <div class="ml-auto">
                                        <CustomInput type="switch" checked={useExistingDestinationPath == true} id="setPostInstallCommands" on:change={() => setUseExistingDestinationPath()} label="Use Existing Destination Path"></CustomInput>
                                    </div>
                                {/if}
                            </div>
                            <input id="destination-input" type="text" class="form-control use-existing" placeholder="Destination Path" bind:value={destinationPath} disabled={useExistingDestinationPath}>
                            <small>Must be a system file path eg: C:\Transfers</small>
                        </div>
                    {/if}
                </div>
            {/if}
        
            {#if multiStepValue > 1}
                <div transition:slide>
                    <h4 class="input-header mt-2 mb-2 m-2">Version Files</h4>
                    <Dashboard {uppy} props={uppyProps} />
                    {#if showSelectPrimaryFiles}
                        <h4 class="input-header mt-2 mb-3 m-2">Primary File</h4>
                        <div class="mb-2">
                            <select id="uploadOptions" disabled={!primaryFiles.length > 0 ? true : false} placeholder="Select Primary File"  bind:value={selected} class="form-control">
                                {#each primaryFiles as file}
                                    <option value={file}>{file.name}</option>
                                {/each}
                            </select>
                        </div>
                    {/if}
                </div>
            {/if}
            <p class="text-danger">{errorMessage}</p>
        </div>
    </ModalBody>
    <ModalFooter>
        <button class="btn btn-outline-primary" on:click={() => toggle()} id="cancel-button">Cancel</button>
        {#if maxMultiStepValue > multiStepValue}
            <button class="btn btn-primary" on:click={() => multiStepValue++} id="next-button">Next</button>
            {:else}
            <button class="btn btn-primary" on:click={() => runValidation()} disabled={errorMessage != ""} id="create-package-button">Create Package {mode == softwareMode ? "" : "Version"}</button>
        {/if}
    </ModalFooter>
</Modal>

<style>
    @import "@uppy/core/dist/style.css";
    @import "@uppy/dashboard/dist/style.css";

    .modalHeading{
        font-weight: 500;
    }

    textarea {
        white-space: nowrap;
        max-height: 150px;
  }

  .btn-link{
    opacity: 0.5;
  }

  .active{
    opacity: 1;
  }

   input[type="text"]:disabled{
    background-color: #e9ecef;
  }

</style>